export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14135.7b880166.jpg";